import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/inspectNode/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/inspectNode/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/inspectNode/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/inspectNode/submit', params, options);

export const update = (params, options) => request.post('/api/inspectNode/submit', params, options);

export const updateStatusForbid = (params, options) =>
  request.post('/api/inspectNode/updateStatusForbid', qs.stringify(params), options);
export const updateStatusStart = (params, options) =>
  request.post('/api/inspectNode/updateStatusStart', qs.stringify(params), options);

export const getInspectNodeTree = (id) => {
  return request({
    url: 'api/inspectNode/inspectNodeTree',
    method: 'get',
    params: {
      id,
    },
  });
};
